<div class="language-picker-container">
  @if ((settingsObservable | async); as settings) {
    @if (settings.languages.length > 1) {
      <app-language-picker [languages]="settings.languages"/>
    }
  }
</div>
<header>
  @if (settingsObservable | async; as settings) {
    <div class="logo">
      @if (settings?.websiteUrl) {
        <a
            [href]="$safeNavigationMigration(settings?.websiteUrl)"
            target="_blank">
          <ng-container *ngTemplateOutlet="logoImage"/>
        </a>
      } @else {
        @if (settings?.logoUrl) {
          <img class="tw-inline"
               [alt]="$safeNavigationMigration(settings?.name)"
               [src]="$safeNavigationMigration(settings?.logoUrl)">
        } @else {
          <h1>{{ settings?.name }}</h1>
        }
      }
      <ng-template #logoImage>
        @if (settings?.logoUrl) {
          <img class="tw-inline"
               [alt]="$safeNavigationMigration(settings?.name)"
               [src]="$safeNavigationMigration(settings?.logoUrl)">
        } @else {
          <h1>{{ settings?.name }}</h1>
        }
      </ng-template>
      @if (settings?.additionalIndexHtml && customHTML()) {
        <div
            [innerHTML]="$safeNavigationMigration(settings?.additionalIndexHtml)">
        </div>
      }
    </div>
  }
</header>
